<template>
  <div>
    <el-header style="margin: 15px" >
      <breadcrumb></breadcrumb>
    </el-header> 
    <el-main v-loading.fullscreen.lock="loading">
      <el-form :model="form" ref="form" label-width="180px" :rules="rules">    
        <el-row style="text-align:right; padding-bottom: 10px;" v-if="!isCustomer && form.status == 'Done' && lockAll">  
          <el-col :span="24" >
            <el-button type="danger" @click="rejectInstall()">{{$t('button.reject')}}</el-button>  
          </el-col>  
        </el-row>

        <el-row >
          <el-col :span="12" >
            <el-form-item :label="$t('field.installedTime')" prop="installedTime" >
              <el-date-picker v-model="form.installedTime"  type="date" :placeholder="$t('msg.selectDate')" :disabled="lockAll"  :picker-options="pickerOptions"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!isCustomer "> 
            <CustomerSearch v-model="form.custSapCode"  @sync-select-customer="syncSelectCustomer" v-if="(form.status ==null || form.status =='')" />
             <el-form-item :label="$t('field.customerNo')" v-if="(form.status !=null && form.status !='') " >
              <el-input v-model="form.custSapCode"  :disabled="true" />
            </el-form-item>

          </el-col>
          <el-col :span="12" v-if="isCustomer">            
            <el-form-item :label="$t('field.customerNo')"  v-if="(form.status ==null || form.status ==''|| form.status =='Draft') "  >
              <el-select v-model="form.custSapCode" :placeholder="$t('msg.pleaseSelect')" style="width:100%"  :disabled="lockAll">
                <el-option v-for="item in custSapNoOpts"  :key="item.key"  :label="item.value" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('field.customerNo')" v-if="(form.status !=null && form.status !='' && form.status !='Draft') " >
              <el-input v-model="form.custSapCode"  :disabled="true" />
            </el-form-item>

          </el-col>
        </el-row> 
    
        <div class="area-desc">
          <el-row>
            <el-col :span="12">           
              <el-form-item :label="$t('field.institutionName')" prop="institutionName" >
                <el-input v-model="form.institutionName" maxlength=500 :disabled="lockAll"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('field.institutionCountry')" prop="institutionCountry">               
                <el-select v-model="form.institutionCountry" :placeholder="$t('msg.pleaseSelect')" style="width:100%" :no-data-text="$t('msg.noDataFound')" :disabled="lockAll" filterable>
                  <el-option v-for="item in institutionCountryOpts"  :key="item.value"  :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
        </el-row>
        <el-row >
          <el-col :span="12">           
            <el-form-item　:label="$t('field.institutionCity')" prop="institutionCity">
              <el-input v-model="form.institutionCity" maxlength=500 :disabled="lockAll"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">           
            <el-form-item :label="$t('field.status')" >
              <el-input v-model="form.status" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
    </div>
    <br>
    <div class="area-desc">
      <span class="area-header">{{$t('field.hardware')}}</span>
      <el-row>       
        <el-col :span="12">
          <el-form-item :label="$t('field.dRSerialNo')" prop="serialno">     
            <el-select v-model="form.serialno" filterable :placeholder="$t('msg.pleaseSelect')" style="width:100%" :no-data-text="$t('msg.noDataFound')"
               @change="checkSnAction()" :disabled="lockAll" allow-create>
              <el-option v-for="item in serialnoOpts"  :key="item.label"  :label="item.label" :value="item.label"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">           
          <el-form-item :label="$t('field.fwVersion')">
            <el-input v-model="form.fwVersion" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </div>
    <br>
    <div class="area-desc">
      <span class="area-header">{{$t('field.software')}}</span>
      <el-row>       
        <el-col :span="12">
          <el-form-item :label="$t('field.softwareType')" prop="sw">               
            <el-select v-model="form.sw" :placeholder="$t('msg.pleaseSelect')" style="width:100%" :no-data-text="$t('msg.noDataFound')" @change="checkSwAction()" :disabled="lockAll">
              <el-option v-for="item in swOpts"  :key="item"  :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>   
        <el-col :span="12">           
          <el-form-item :label="$t('field.softwareVersion')" prop="version">
            <el-select v-model="form.version" :placeholder="$t('msg.pleaseSelect')" style="width:100%" :no-data-text="$t('msg.noDataFound')" :disabled="lockAll">
              <el-option v-for="item in versionOpts"  :key="item"  :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>       
        <el-col :span="12">
          <el-form-item :label="$t('field.updPackageVer')" >               
            <el-select v-model="form.updVersion" :placeholder="$t('msg.pleaseSelect')" style="width:100%" :no-data-text="$t('msg.noDataFound')" :disabled="lockAll">
              <el-option v-for="item in updVersionOpts"  :key="item"  :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">           
          <el-form-item :label="$t('field.dongleSerialNo')" >
            <el-input v-model="form.dongle"  :disabled="lockAll" class="uppercase" placeholder="DROCxxxxxxxxxx,VETDROCxxxxxxxxxx,VETWSxxxxxxxxxx,NWSxxxxxxxxxx"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      </div>
      <br>
      <div class="area-desc">
        <span class="area-header">{{$t('field.otherSoftwareInstalledOptional')}}</span>
        <el-row>         
          <el-col :span="8">           
            <el-form-item :label="$t('field.flyviewerVer')">
              <el-input v-model="form.fvVersion" maxlength=100 :disabled="lockAll"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">           
            <el-form-item :label="$t('field.workStationVer')" label-width="150px">
              <el-input v-model="form.wsVersion" maxlength=100 :disabled="lockAll"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">           
            <el-form-item :label="$t('field.webPACSVer')" label-width="150px">
              <el-input v-model="form.wpVersion" maxlength=100 :disabled="lockAll"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <br>
      <el-row>
        <el-col :span="24">
          <el-form-item :label="$t('field.fileRemark')" >
            <el-input type="textarea" v-model="form.remark" maxlength=3000 rows="5" :disabled="lockAll"></el-input>
          </el-form-item>
        </el-col>
      </el-row> 
      <FileEditList ref="fileList" :onlyView="lockAll" :docId.sync="form.id" uploadType="installed" />
      <br>      
      <el-row style="padding-top: 10px;text-align:center" v-if="!lockAll" >  
        <el-col :span="24" >
          <el-button type="warning" @click="save()">{{$t('button.save')}}</el-button>    
          <el-button type="warning" @click="submit()">{{$t('button.submit')}}</el-button>
        </el-col>  
      </el-row>
    </el-form>
    </el-main>
  </div>
</template>

<script>
import Breadcrumb from '../components/Breadcrumb';
import CommonUtil from "../../utils/commonUtil.js";
import FileEditList from "../components/FileEditList";
import CustomerSearch from "../components/CustomerSearch";

import { apiFindInstall, apiFindSysAttrValueByCategory, apiFindHardwareDrSn,apiFindSoftwareVersionByName, apiFindSoftwareUpdVersion, apiFindSoftwareDongleSn,
         apiSaveInstall, apiSubmitInstall, apiFindCustSapNoByWindowsAccount, apiRejectInstall} from "../../utils/api.js";
import authHeader from "../../services/auth-header";


//https://sdk.amazonaws.com/js/aws-sdk-2.812.0.js

export default {
  name: 'createinstalledMachine',
  data() {   
    return {  
      // nameComputed :'',  
      loading:false, 
      lockAll : false,
      form: {       
        id :'',
        installedTime :'',
        institutionName :'',
        institutionCountry :'',
        institutionCity :'',
        serialno :'',
        fwVersion:'',
        sw :'',
        version :'',
        updVersion :'',
        dongle :'',
        fvVersion :'',
        wsVersion :'',
        wpVersion :'',
        remark  :'',        
        custSapCode:'',
        model:'',
        status:'',
      },
      value2: "",
      custSapNoOpts:[],
      serialnoOpts : [],
      swOpts:['HumanDROC', 'VetDROC'],
      versionOpts:[],
      updVersionOpts :[],
      institutionCountryOpts:[],
      rules: {
        installedTime: [ { required: true, message: this.$i18n.t('msg.fieldNotEmpty'), trigger: 'blur' }],
        institutionName: [ { required: true, message: this.$i18n.t('msg.fieldNotEmpty'), trigger: 'blur' } ],
        institutionCountry: [ { required: true, message: this.$i18n.t('msg.fieldNotEmpty'), trigger: 'change' }],
        institutionCity: [ { required: true, message: this.$i18n.t('msg.fieldNotEmpty'), trigger: 'blur' }],
        serialno: [ { required: true, message: this.$i18n.t('msg.fieldNotEmpty'), trigger: 'change' }],
        sw: [ { required: true, message: this.$i18n.t('msg.fieldNotEmpty'), trigger: 'change' }],
        version: [ { required: true, message: this.$i18n.t('msg.fieldNotEmpty'), trigger: 'change' }],
        // updVersion: [ { required: true, message: this.$i18n.t('msg.fieldNotEmpty'), trigger: 'change' }]       
      },      
      isCustomer:false,
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() > Date.now() ;
        }
    }
    };
  },   
  components: {
    Breadcrumb,
    FileEditList,
    CustomerSearch
  },
  watch: {
    'form.dongle': { // 深度监听，可监听到对象、数组的变化
      handler (val, oldVal) {
        if(this.form.dongle!=null && this.form.dongle != ''){
          this.form.dongle = val.toUpperCase();
        }
        
      },
      deep: true
    }
  },
  mounted() {
    apiFindSysAttrValueByCategory({ headers: authHeader(), condition: 'COUNTRY'}).then((response) => { 
      this.institutionCountryOpts = [];
      response.data.forEach((item, index) => {   
        this.institutionCountryOpts.push({ value: item.key, label: item.key +' '+ item.value });
      });
    }).catch((err) => {
      console.log(err);
    });
    this.loadSerialNo();

    if(this.form.id != null && this.form.id != ''){
      apiFindInstall({ headers: authHeader(), id:this.form.id}).then((response) => { 
        response.data.lockAll = false;
        this.form = response.data;  
        if(this.form.serialno != null){
            this.checkSnAction();
        }
        if(this.form.sw != null){
            this.checkSwAction();
        }        
        if(this.form.status == 'Done'){
          this.lockAll = true;
        }
      }).catch((err) => {
        console.log(err);
      });   
    }
  },
  created(){   

    this.isCustomer = this.$store.state.auth.user.username.indexOf('@')>-1 ? true : false;      
    this.form.id = this.$route.params.id;
    if(this.form.id == null){
      console.log("create");
    }else {
      console.log("modify:"+this.form.id );
    }
    if(this.isCustomer){
      apiFindCustSapNoByWindowsAccount({ headers: authHeader()}).then((response) => { 
        if(response.status== 200 && response.data != null){
          this.custSapNoOpts = response.data;
          this.form.custSapCode = this.custSapNoOpts[0].key;
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  },
  methods: {
    loadSerialNo(){
      apiFindHardwareDrSn({ headers: authHeader(), custNo: this.form.custSapCode}).then((response) => {   
        this.serialnoOpts = [];
        response.data.forEach((item, index) => {   
          this.serialnoOpts.push({ label: item.serialNo +'('+ item.model + ', '+item.fwVersion+', '+ item.invoiceNo + ')' });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    dongleFormatChk(){
    // DROC + 10碼數字
    // VETDROC + 10碼數字
    // VETWS + 10碼數字
    // NWS + 10碼數字


      var dongle = this.form.dongle;
      var formatArr = ['DROC','VETDROC','VETWS', 'NWS'];
      var re = /^[0-9]+$/;//判斷字串是否為數字//判斷正整數/[1−9] [0−9]∗]∗/     
      var result = false;

      
      if(!CommonUtil.isNull(dongle)){
        this.form.dongle = this.form.dongle.trim();
        formatArr.forEach(function(item){
          if(dongle.startsWith(item)){    
            var tempNumber = dongle.replace(item, '');
            if(tempNumber != null && tempNumber != ''){
              tempNumber = tempNumber.trim();
              if (tempNumber.length == 10 && re.test(Number(tempNumber))) { 
          　　　 result = true;
                return;
          　　}else {
                return;
              }  
            }
                
          }
        });
      }else{
        result = true;
      }
      
      return result;      
    },
    save(){      
      if(this.dongleFormatChk()){
          this.$refs['form'].validate((isValid) => {        
          if (!isValid) {
            return this.$message.warning({message: this.$i18n.t('msg.incompleteInfo'), duration: 800});
          }else{
            debugger
            apiSaveInstall({ headers: authHeader(), installed: this.form, custSapCode: this.form.custSapCode}).then((response) => {               
              if(response.data.installed.id != null ){
      
                this.form.id = response.data.installed.id;
                this.$refs.fileList.docId = this.form.id;               
                this.$refs.fileList.save();

                this.$router.push("/createinstalledMachine/" +  this.form.id);
                this.loading = false;
                this.$message({ type: "success", message: this.$i18n.t('msg.saveSuccess'), duration: 800});
 setTimeout(( () => location.reload()), 900);
              }else{
                this.loading = false;
                this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 800});
              }          
            }).catch((err) => {
              console.log(err);
              this.loading = false;
              this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 800});
            });
          }
        });
      }else{
        this.$message({ type: "error", message: this.$i18n.t('msg.dongleFormatWrong'), duration: 800});
      }
      
      
    },
    submit(){
      if(this.dongleFormatChk()){
        this.$refs['form'].validate((isValid) => {  
        if (!isValid) {
          return this.$message.warning({message: this.$i18n.t('msg.incompleteInfo'), duration: 800});
        }else{
          //step 1. Symptom, systemName retrofit hospitalName country frequency不得為空
          this.$confirm(this.$i18n.t('msg.confirmSubmitInstalled'),{
              confirmButtonText: this.$i18n.t('button.confirm'),
              cancelButtonText: this.$i18n.t('button.cancel'),
              type: 'warning'
            }).then(_ => {           
              this.loading = true;
              apiSubmitInstall({ headers: authHeader(), installed: this.form, custSapCode: this.form.custSapCode }).then((response) => { 
                debugger
                if(response.data.installed.id != null ){
                  this.form.id = response.data.installed.id;
                  this.form.status = response.data.installed.status;
                  this.lockAll = true;
                  this.$router.push("/createinstalledMachine/" +  this.form.id);
                  this.loading = false;
                  this.$message({ type: "success", message: this.$i18n.t('msg.submitSuccess'), duration: 1000});
                  setTimeout(( () => location.reload()), 900);
                }else{
                  this.loading = false;
                  this.$message({ type: "error", message: this.$i18n.t('msg.submitFail'), duration: 1500});
                }
                  
              }).catch((err) => {
                debugger
                this.loading = false;
                this.$message({ type: "error", message: this.$i18n.t('msg.submitFail'), duration: 1500});
              });
                
              done();
            }).catch(_ => {});
          }        
        });
      } else {
        this.$message({ type: "error", message: this.$i18n.t('msg.dongleFormatWrong'), duration: 800});
      }
      
    },
    syncSelectCustomer(custNo){            
      this.form.custSapCode = custNo;
      this.loadSerialNo();
    },
    checkSnAction(){  
      this.form.fwVersion = ''
      this.form.model  = ''
      if(this.form.serialno!=null && this.form.serialno != '' 
       && this.form.serialno.indexOf('(') > 0 && this.form.serialno.indexOf(')') > 0){
        var otherInfo =  this.form.serialno.split('(')[1].replace(')', '');   
        if(otherInfo != null && otherInfo != ''){
          this.form.model = otherInfo.split(',')[0].trim();
          this.form.fwVersion = otherInfo.split(',')[1].trim();
        }  
      }
       
     

      // apiFindSoftwareDongleSn({ headers: authHeader(), sn: this.form.serialno.split('(')[0]}).then((response) => {   
      //   if(response.data != null && response.data.length >0){
      //     this.form.dongle = response.data[0].key;
      //   }
      // }).catch((err) => {
      //   console.log(err);
      // });

    },
    checkSwAction(){
      
      apiFindSoftwareUpdVersion({ headers: authHeader(), name: this.form.sw}).then((response) => { 
        this.updVersionOpts = [];  
        response.data.forEach((item, index) => {           
          this.updVersionOpts.push(item.key);
        });
        this.updVersionOpts.push('無版本/No version');
      }).catch((err) => {
        console.log(err);
      });

      apiFindSoftwareVersionByName({ headers: authHeader(), name:  this.form.sw}).then((response) => {   
        this.versionOpts=[];
        response.data.forEach((item, index) => { 
          this.versionOpts.push(item.key);
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    rejectInstall(){
      this.$confirm(this.$i18n.t('msg.confirmRejectInstalled'), {
        confirmButtonText: this.$i18n.t('button.confirm'),
        cancelButtonText: this.$i18n.t('button.cancel'),
        type: 'warning'
      }).then(_ => {
        this.loading = true;           
        apiRejectInstall({ headers: authHeader(), id: this.form.id}).then((response) => {            
          if(response.status== 200 && response.data ){   
            this.form.status = 'Draft';
            this.loading = false;
            this.$message({ type: "success", message: this.$i18n.t('msg.saveSuccess'), duration: 800});
            setTimeout(( () => location.reload()), 900);
          }else{
            this.loading = false;
            this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 800});
          }          
        }).catch((err) => {
          console.log(err);
          this.loading = false;
          this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 800});
        });
        
        done();
      }).catch(_ => {});
    }
  }
};
</script>

<style scoped>
.el-select .el-select--small {
  width: 100%;
}

input {
  width: 100%;
}

.area-desc {
  background-color: #ead8d2ab;
  padding-top: 10px;
  padding-right: 10px;
}

.area-header {
  font-weight: bold; 
  position: relative; 
  top: -20px; 
  left: 15px;
}
</style>